import { requisitarJson } from '../../../shared/api/http';

/** O que o jogo respondeu ao disparo: o relógio da animação e a fotografia dos insights. */
export interface DisparoDoBossFinal {
    inicia_em: string;
    duracao_ms: number;
    total_insights: number;
    fotografia_nova: boolean;
}

/**
 * Dispara o Boss Final da turma (`POST /api/v1/boss-final/iniciar`): o painel pede, o jogo cria ou
 * reusa a fotografia e a trilha registra. A animação roda aqui, no próprio painel.
 */
export function iniciarBossFinal(pedido: { turmaId: string; csrfToken: string }): Promise<DisparoDoBossFinal> {
    return requisitarJson('/api/v1/boss-final/iniciar', {
        method: 'POST',
        csrfToken: pedido.csrfToken,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ turma_id: pedido.turmaId }),
    });
}
